module.exports = __webpack_public_path__ + "static/media/icon-6.e52f2edd.png";